<template>
  <div class="page">
    <el-page-header @back="onBack" title="" content="學習表現-作業"></el-page-header>
    <div class="page-content">
        <el-form :model="from" label-position="left" label-width="80px"  :rules="rules" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="作業名称" prop="homeworkId">
            <el-select v-model="from.homeworkId" placeholder="全部">
              <el-option
                v-for="item in homeworks"
                :key="item.id"
                :label="item.number"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分校" prop="branchSchoolId">
            <el-select v-model="from.branchSchoolId" placeholder="全部">
              <el-option
                v-for="item in sortBranchesList"
                :key="item.id"
                :label="item.abbreviation"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="info" @click="onExport">導出</el-button>
          </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import {downloadFile} from '@/utils/is-rules'
import {getHomeworkReport} from "@/api/report";
import { getHomeworks } from "@/api/homeworks";
import { getBranchSchools } from "@/api/setting";
import { getGrades } from '@/api/grade'
export default {
  data() {
    return {
      homeworks: [],
      tableData: [],
      allGrades: [],
      from: {
        homeworkId: null,
        branchSchoolId: null,
      },
      rules:{
        homeworkId: [
          { required: true, message: '作業名称', trigger: 'change' }
        ],
        branchSchoolId:[{ required: true, message: '分校', trigger: 'change' }],
      }
    };
  },
  created() {
    this.getHomeworks()
    this.getAllGrades()
    this.getBranchSchools()
  },
  methods: {
    getHomeworks() {
      let formLabelAlign = {
        _page: 0,
        _limit: 50,
      };
      getHomeworks(formLabelAlign).then((v) => {
        this.homeworks = v.data;
      });
    },
    getAllGrades(){
        let formLabelAlign = {
          _page: 0,
          _limit: 0,
        }
       getGrades(formLabelAlign).then((v)=>{
          this.allGrades = v.data
       })
    },
    getBranchSchools() {
      getBranchSchools().then((v) => {
        this.tableData = v.data;
      });
    },
    onExport(){
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.getHomeworkReport()
        }
      })
    },
    getHomeworkReport(){
      let formLabelAlign = {
            homeworkId: this.from.homeworkId,
            branchSchoolId: this.from.branchSchoolId,
          }
      getHomeworkReport(formLabelAlign).then((v)=>{
        downloadFile(v.data,'學習表現-作業.xlsx')
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.el-page-header{
  margin-bottom: 20px;
}
.page-title{
  margin-bottom: 20px;
}
.page-content{
  background-color: #fff;
  padding: 20px;
}
</style>